import { Component, OnInit, AfterViewInit } from "@angular/core";
import { ReportService } from "../report.service";
//Import Custom Services Here
import { SchoolService } from "../../../shared/services/school.service";
import { InstructorService } from "../report-services/instructor.service";
import { CourseService } from "../report-services/course.service";
import { SectionNoService } from "../report-services/section-no.service";
import { ClassAttendanceStatusService } from "../report-services/class-attendance-status.service";
import { ClassAttendanceEntryTypeService } from "../report-services/class-attendance-entry-type.service";
import { SchoolselectorService } from "../../schoolselector/schoolselectorservice.service";
import { DialogService } from "primeng/dynamicdialog";
import { MergeToGroupRequest } from "../report-services/merge-to-group-request";
import { MergeToGroupDialogComponent } from "../merge-to-group-dialog/merge-to-group-dialog.component";
import * as moment from "moment";

@Component({
	templateUrl: "./classattendancesummary.component.html",
})
export class ClassAttendanceSummaryComponent implements OnInit {
	constructor(
		private selectService: SchoolselectorService,
		private reportService: ReportService,
		//Insert Custom Services Here
		private classattendanceentrytypeService: ClassAttendanceEntryTypeService,
		private classattendancestatusService: ClassAttendanceStatusService,
		private sectionnoService: SectionNoService,
		private courseService: CourseService,
		private instructorService: InstructorService,
		private schoolService: SchoolService,
		private dialogService: DialogService
	) {}
	report = {
		//Insert Custom Parameters Here
		SchoolID: 0,
		InstructorID: 0,
		CourseID: 0,
		SectionNoID: 0,
		StartDate: new Date(),
		EndDate: new Date(),
		ClassAttendanceStatusID: 0,
		ClassAttendanceEntryTypeID: 0,
		ImageLogo: "",
	};

	//Insert Custom Lists Here
	schoolList: any = [];
	InstructorList: any = [];
	CourseList: any = [];
	SectionNoList: any = [];
	ClassAttendanceStatusList: any = [];
	ClassAttendanceEntryTypeList: any = [];
	ImageLogoList: any = [];

	OutputTypeID: any = 1;
	OutputTypeList = [
		{
			ID: 1,
			Desc: ".PDF",
		},
		// {
		//     ID: 2,
		//     Desc: ".Doc (Word Document)" //Doesn't seem to work
		// },
		// {
		//     ID: 3,
		//     Desc: ".xls (Excel file)" //Ending Support for xls, just use CSV
		// },
		{
			ID: 4,
			Desc: ".CSV (Excel file)",
		},
		{
			ID: 5,
			Desc: ".RTF (Rich Text File)",
		},
		// {
		//     ID: 6,
		//     Desc: ".XML" //Doesn't seem to work
		// },
		{
			ID: 7,
			Desc: ".HTM (Web Page)",
		},
		// {
		//     ID: 8,
		//     Desc: ".rpt" //Doesn't seem to work
		// },
		// {
		//     ID: 9,
		//     Desc: ".grp" //Doesn't seem to work
		// }
	];

	ReportID: number = 254;
	subscription: any;

	user: any;
	errorMessage: any = "";
	isProcessing: any = false;
	ngOnInit() {
		//Insert Custom Init Methods Here
		// this.loadSchoolist()
		// this.loadInstructorList()
		// this.loadCourseList()
		// this.loadSectionNoList()
		// this.loadClassAttendanceStatusList()
		// this.loadClassAttendanceEntryTypeList()

		this.subscription = this.selectService.onSchoolChanged().subscribe((school) => {
			// this.SchoolID = school.SchoolID;
			this.onSchoolChange(school.SchoolID);
		});
	}

	ngOnDestroy() {
		this.subscription.unsubscribe();
	}

	onSchoolChange(value) {
		this.report.SchoolID = value;
		this.loadInstructorList();
		this.loadCourseList();
		this.loadSectionNoList();
		this.loadClassAttendanceStatusList();
		this.loadClassAttendanceEntryTypeList();
		this.loadLogolist();
	}

	private loadSchoolist() {
		var result = this.schoolService.GetSchoolsForUserReport(254);
		result.subscribe(
			(response) => {
				this.schoolList = response;

				if (this.schoolList.length > 1) {
					this.schoolList.unshift({
						SchoolID: 0,
						SchoolName: "All Schools",
					});
				} else {
					this.onSchoolChange(this.schoolList[0].SchoolID);
				}
			},
			(error) => {}
		);
	}

	private loadInstructorList() {
		this.report.InstructorID = 0;
		var result = this.instructorService.loadInstructorList(0, this.report.SchoolID);
		result.subscribe(
			(response) => {
				this.InstructorList = response;

				this.InstructorList.unshift({
					Teacher_PersonID: 0,
					Instructor: "All Instructors",
				});

				this.report.InstructorID = this.InstructorList[0].Teacher_PersonID;
			},
			(error) => {}
		);
	}

	private loadCourseList() {
		this.report.CourseID = 0;
		var result = this.courseService.loadCourseList(0, this.report.SchoolID);
		result.subscribe(
			(response) => {
				this.CourseList = response;

				if (this.CourseList.length > 1) {
					// this.CourseList.unshift({
					//     CourseID: 0,
					//     CourseDesc: "All Courses"
					// })
				} else {
					this.report.CourseID = this.CourseList[0].CourseID;
				}
			},
			(error) => {}
		);
	}

	private loadSectionNoList() {
		this.report.SectionNoID = 0;
		var result = this.sectionnoService.loadSectionNoList(0, this.report.SchoolID);
		result.subscribe(
			(response) => {
				this.SectionNoList = response;

				if (this.SectionNoList.length > 1) {
					// this.SectionNoList.unshift({
					//     SectionID: 0,
					//     SectionDesc: "All SectionNos"
					// })
				} else {
					this.report.SectionNoID = this.SectionNoList[0].SectionID;
				}
			},
			(error) => {}
		);
	}

	private loadClassAttendanceStatusList() {
		this.report.ClassAttendanceStatusID = 0;
		var result = this.classattendancestatusService.loadClassAttendanceStatusList(0, this.report.SchoolID);
		result.subscribe(
			(response) => {
				this.ClassAttendanceStatusList = response;

				if (this.ClassAttendanceStatusList.length > 1) {
					// this.ClassAttendanceStatusList.unshift({
					//     ClassAttendanceStatusID: 0,
					//     ClassAttendanceStatusDesc: "All ClassAttendanceStatuss"
					// })
				} else {
					this.report.ClassAttendanceStatusID = this.ClassAttendanceStatusList[0].ClassAttendanceStatusID;
				}
			},
			(error) => {}
		);
	}

	private loadClassAttendanceEntryTypeList() {
		this.report.ClassAttendanceEntryTypeID = 0;
		var result = this.classattendanceentrytypeService.loadClassAttendanceEntryTypeList(0, this.report.SchoolID);
		result.subscribe(
			(response) => {
				this.ClassAttendanceEntryTypeList = response;

				if (this.ClassAttendanceEntryTypeList.length > 1) {
					// this.ClassAttendanceEntryTypeList.unshift({
					//     ClassAttendanceEntryTypeID: 0,
					//     ClassAttendanceEntryTypeDesc: "All ClassAttendanceEntryTypes"
					// })
				} else {
					this.report.ClassAttendanceEntryTypeID = this.ClassAttendanceEntryTypeList[0].ClassAttendanceEntryTypeID;
				}
			},
			(error) => {}
		);
	}

	private loadLogolist() {
		var result = this.reportService.ImageLogoGetList("", this.report.SchoolID);
		result.subscribe(
			(response) => {
				this.ImageLogoList = response;

				this.report.ImageLogo = this.ImageLogoList[0].ImageLibraryID;
			},
			(error) => {}
		);
	}

	Print() {
		var component = this;
		this.errorMessage = "";

		//Insert Custom Error Checks Here
		if (!this.report.SchoolID) {
			this.errorMessage = "Select the School";
			return;
		}

		// if (!this.report.InstructorID) {
		// 	this.errorMessage = "Select the Instructor"
		// 	return;
		// }

		// if (!this.report.CourseID) {
		// 	this.errorMessage = "Select the Course"
		// 	return;
		// }

		// if (!this.report.SectionNoID) {
		// 	this.errorMessage = "Select the SectionNo"
		// 	return;
		// }

		// if (!this.report.StartDate) {
		// 	this.errorMessage = "Select the StartDate"
		// 	return;
		// }

		// if (!this.report.EndDate) {
		// 	this.errorMessage = "Select the EndDate"
		// 	return;
		// }

		// if (!this.report.ClassAttendanceStatusID) {
		// 	this.errorMessage = "Select the ClassAttendanceStatus"
		// 	return;
		// }

		// if (!this.report.ClassAttendanceEntryTypeID) {
		// 	this.errorMessage = "Select the ClassAttendanceEntryType"
		// 	return;
		// }

		var strParam = this.GetStrParam();
		this.isProcessing = true;

		var reportID = 254;

		var result = this.reportService.Print(reportID, strParam, this.report.SchoolID, this.OutputTypeID);

		result.subscribe(
			(response: any) => {
				component.isProcessing = false;
				window.open(response);
			},
			(error) => {
				component.errorMessage = error;
				component.isProcessing = false;
			}
		);
	}

	GetStrParam(): string {
		var strParam: string = "";

		//Parameter 1: SchoolID
		strParam += this.report.SchoolID + "|SchoolID";

		//Parameter 2: InstructorID
		strParam += "," + this.report.InstructorID + "|InstructorID";

		//Parameter 3: CourseID
		strParam += "," + this.report.CourseID + "|CourseID";

		//Parameter 4: SectionNo
		strParam += "," + this.report.SectionNoID + "|SectionNo";

		//Parameter 5: StartDate
		strParam += "," + moment(this.report.StartDate).format("MM/DD/YYYY") + "|StartDate";

		//Parameter 6: EndDate
		strParam += "," + moment(this.report.EndDate).format("MM/DD/YYYY") + "|EndDate";

		//Parameter 7: ClassAttendanceStatusID
		strParam += "," + this.report.ClassAttendanceStatusID + "|ClassAttendanceStatusID";

		//Parameter 8: ClassAttendanceEntryTypeID
		strParam += "," + this.report.ClassAttendanceEntryTypeID + "|ClassAttendanceEntryTypeID";

		//Parameter 9: ImageLogo
		strParam += "," + this.report.ImageLogo + "|Imagelogo";

		return strParam;
	}

	MergeToGroup() {
		this.errorMessage = "";

		this.isProcessing = true;
		var strParam = this.GetStrParam();

		var parms: MergeToGroupRequest = {
			ReportID: this.ReportID,
			SchoolID: this.report.SchoolID,
			strParms: strParam,
		};

		var result = this.reportService.MergeToGroupSelectInfo(parms);
		result.subscribe(
			(response: any) => {
				if (response.length > 0) {
					var ref = this.dialogService.open(MergeToGroupDialogComponent, {
						header: "Merge to Group",
						width: "fit-content",
						data: {
							//INSERT Custom Data here
							lstPerson: response,
							SchoolID: this.report.SchoolID,
						},
					});
					ref.onClose.subscribe((response) => {
						if (response == 1) {
						}
					});
				} else {
					this.errorMessage = "No Data available";
				}

				this.isProcessing = false;
			},
			(error) => {
				this.errorMessage = error;
				this.isProcessing = false;
			}
		);
	}
}
